import NewArticle from './NewArticle'
export default NewArticle
